export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13024.f56a3960.jpg";